import {http} from '@/http/axios.js'


// 导入SIM年费数据
export function importSimYearFeeAPI(data) {
    return http({
        url: `/api/admin/pos-data/import/importSimYearFee`,
        method: 'post',
        data
    })
}


export function getImportProcessApi(task_id) {
    return http({
        url: `/api/admin/pos-data/import/getImportResult`,
        method: 'GET',
        params: {
            task_id
        }
    })
}
